import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { Filter, ChevronDown } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { namespace } from '@common/config/constants';
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { getViewFiltersCount } from '@common-reducers/TasksFilterPanelThunks';
import FilterSection from "./filter_section";
import { cn } from "@/lib/utils";

export default function OpenFilterPanelButtonShadcn() {
    const { t } = useTranslation(namespace);
    const [open, setOpen] = useState(false);
    const [isQuickFilter, setIsQuickFilter] = useState(true);
    
    // Portal reasoning
    

    const currentFilterCount = useAppSelector((state) => getViewFiltersCount(state));
    const active = currentFilterCount > 0;

    const handleMainClick = () => {
        setIsQuickFilter(true);
        setOpen(true);
    };

    const handleArrowClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsQuickFilter(false); 
        setOpen(true);
    };

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <div className="flex items-center">
                <PopoverTrigger asChild>
                    <div className="flex">
                         {/* Main Filter Button */}
                        <Button
                            variant="ghost"
                            size="sm"
                            className={cn(
                                "h-9 rounded-r-none border-none shadow-none gap-2 px-3 transition-all",
                                active 
                                    ? "bg-primary/10 text-primary hover:bg-primary/20 opacity-100" 
                                    : "opacity-50 hover:opacity-100 text-muted-foreground"
                            )}
                            onClick={handleMainClick}
                            data-testid="filter-button-main"
                        >
                            <Filter className="h-4 w-4" />
                            <span>{t('openFilterPanelButton.filterButtonLabel', 'Filter')}</span>
                            {currentFilterCount > 0 && (
                                <Badge 
                                    variant="default" 
                                    className="ml-1.5 size-5 rounded-full p-0 flex items-center justify-center text-[11px] font-bold border-none shadow-none"
                                >
                                    {currentFilterCount}
                                </Badge>
                            )}
                        </Button>

                         {/* Arrow Button */}
                        <Button
                            variant="ghost"
                            size="sm"
                            className={cn(
                                "h-9 px-1 rounded-l-none border-none shadow-none min-w-[1.5rem]",
                                active 
                                    ? "bg-primary/10 text-primary hover:bg-primary/20 opacity-100" 
                                    : "opacity-50 hover:opacity-100 text-muted-foreground"
                            )}
                             onClick={handleArrowClick}
                             data-testid="filter-button-arrow"
                        >
                            <ChevronDown className="h-3 w-3" />
                        </Button>
                    </div>
                </PopoverTrigger>
            </div>
            
            <PopoverContent 
                align="start" 
                className="w-auto p-0"
            >
                {/* We need to pass isQuickFilter to FilterSection */}
                {/* FilterSection expects isQuickFilter prop but also handles its own state switch internally? */}
                {/* Looking at FilterSection code: `const [quickFilter, setQuickFilter] = useState<boolean>(isQuickFilter)` */}
                {/* So passing it as initial state prop works when mounting, but we need to key it to force update or lift state? */}
                {/* Assigning a key based on open/mode might reset it correctly. */}
                <FilterSection isQuickFilter={isQuickFilter} key={`${open}-${isQuickFilter}`} />
            </PopoverContent>
        </Popover>
    );
}
